import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=2dcc1e66&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"
import style0 from "./PostForm.vue?vue&type=style&index=0&id=2dcc1e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc1e66",
  null
  
)

export default component.exports